import { defineComponent as D, onMounted as S, createBlock as m, openBlock as u, unref as n, withCtx as i, createVNode as e, renderSlot as c, createElementVNode as p, createTextVNode as V, toDisplayString as y, createCommentVNode as C } from "vue";
import $ from "./DownloadLink.vue.js";
import k from "./InfoDescription.vue.js";
import L from "./InfoLinks.vue.js";
import h from "./InfoVersion.vue.js";
import E from "./OpenApiVersion.vue.js";
import N from "../../../../components/Section/SectionContainer.vue.js";
import O from "../../../../components/Section/Section.vue.js";
import B from "../../../../components/Section/SectionContent.vue.js";
import w from "../../../../components/Section/SectionHeader.vue.js";
import F from "../../../../components/Section/SectionHeaderTag.vue.js";
import H from "../../../../components/Section/SectionColumns.vue.js";
import g from "../../../../components/Section/SectionColumn.vue.js";
import v from "../../../../features/specification-extension/SpecificationExtension.vue2.js";
const I = { class: "flex gap-1.5" }, T = { class: "sticky-cards" }, Y = /* @__PURE__ */ D({
  __name: "IntroductionLayout",
  props: {
    oasVersion: {},
    info: {},
    externalDocs: {},
    documentExtensions: {},
    infoExtensions: {},
    isLoading: { type: Boolean },
    getOriginalDocument: { type: Function },
    onLoaded: { type: Function },
    id: {}
  },
  setup(l) {
    return S(() => {
      var o;
      return (o = l.onLoaded) == null ? void 0 : o.call(l);
    }), (o, z) => (u(), m(n(N), null, {
      default: i(() => [
        e(n(O), {
          id: o.id,
          class: "introduction-section z-1 gap-12"
        }, {
          default: i(() => {
            var r, a;
            return [
              e(n(B), {
                loading: o.isLoading ?? (!((r = o.info) != null && r.description) && !((a = o.info) != null && a.title))
              }, {
                default: i(() => {
                  var s, d;
                  return [
                    p("div", I, [
                      e(h, {
                        version: (s = o.info) == null ? void 0 : s.version
                      }, null, 8, ["version"]),
                      e(E, { oasVersion: o.oasVersion }, null, 8, ["oasVersion"])
                    ]),
                    e(n(w), {
                      loading: !((d = o.info) != null && d.title),
                      tight: ""
                    }, {
                      links: i(() => [
                        e(L, {
                          externalDocs: o.externalDocs,
                          info: o.info
                        }, null, 8, ["externalDocs", "info"])
                      ]),
                      default: i(() => [
                        e(n(F), { level: 1 }, {
                          default: i(() => {
                            var t;
                            return [
                              V(y((t = o.info) == null ? void 0 : t.title), 1)
                            ];
                          }),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["loading"]),
                    e(n(H), null, {
                      default: i(() => [
                        e(n(g), null, {
                          default: i(() => {
                            var t, f;
                            return [
                              e($, {
                                getOriginalDocument: o.getOriginalDocument,
                                title: (t = o.info) == null ? void 0 : t.title
                              }, null, 8, ["getOriginalDocument", "title"]),
                              e(k, {
                                description: (f = o.info) == null ? void 0 : f.description
                              }, null, 8, ["description"])
                            ];
                          }),
                          _: 1
                        }),
                        o.$slots.aside ? (u(), m(n(g), { key: 0 }, {
                          default: i(() => [
                            p("div", T, [
                              c(o.$slots, "aside", {}, void 0, !0)
                            ])
                          ]),
                          _: 3
                        })) : C("", !0)
                      ]),
                      _: 3
                    }),
                    e(n(v), { value: o.documentExtensions }, null, 8, ["value"]),
                    e(n(v), { value: o.infoExtensions }, null, 8, ["value"])
                  ];
                }),
                _: 3
              }, 8, ["loading"]),
              c(o.$slots, "after", {}, void 0, !0)
            ];
          }),
          _: 3
        }, 8, ["id"])
      ]),
      _: 3
    }));
  }
});
export {
  Y as default
};
